<div class="modal-header">
  <h5 class="modal-title" id="newRFIDLabel">RFID-Karten anlernen</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>
<div class="modal-body">

  <app-message [service]="messageService"></app-message>
  <p>Der Anlernmodus ermöglicht es, neue RFID-Karten hinzuzufügen, indem man sie einfach vor den Lesebereich der Ladestation hält.</p>
  <form [formGroup]="form" *ngIf="formCreated">
    <div class="form-group mb-3">
      <label for="chargingstation" class="form-label" i18n="@@ChargingstationLabel">Ladestation</label>
      <ng-select #chargingStationSelect id="chargingstation"
                 [items]="chargingStations"
                 [appendTo]="'body'"
                 [placeholder]="'Ladestation'"
                 bindLabel="name"
                 bindValue="id"
                 autofocus
                 formControlName="selectedChargingStationId"
                 (change)="changeChargingStation($event)">
      </ng-select>
    </div>

    <div class="checkbox mb-2 mt-2">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="isScanModeActive" formControlName="isScanModeActive" (change)="scanActiveChanged()" />
        <label class="form-check-label" for="isScanModeActive" i18n="@@IsScanModeActiveLabel">Anlernmodus aktivieren</label>
      </div>
    </div>

    <div class="form-groupmb-3">
      <label for="rfid-tag" class="form-label" i18n="@@Recognized">Erkannt</label>
      <input type="text" disabled class="form-control form-control-plaintext border rounded-3 p-2" id="rfid-tag" value="{{ scannedRfidTag }}" placeholder="Gescannte RFID-Karte" i18n-placeholder="@@ScannedRfidTag"/>
    </div>
  </form>

</div>
<div class="modal-footer">
  <button type="button" id="creat_rfid" class="btn btn-primary" (click)="createRfidCard()" data-bs-dismiss="modal" [disabled]="!scannedRfidTag" i18n="@@CreateRfidFromScanButton">Anlegen</button>
  <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CloseButton">Schließen</button>
</div>
